import { FormBehaviorState } from '../types/formBehavior.types'
import { useAppSelector } from '../utils/agent.store'
import type { RootState } from '../utils/agent.store'
import { EMPTY_FORM_BEHAVIOR_STATE } from './formBehavior.utils'

export const selectFormBehaviorByLayoutUid =
  (uid: string) => (state: RootState) =>
    state.formBehavior?.byLayoutUid[uid]

export const useFormBehaviorState = (layoutUid?: string): FormBehaviorState => {
  return useAppSelector((state) => {
    if (!layoutUid) return EMPTY_FORM_BEHAVIOR_STATE
    return (
      selectFormBehaviorByLayoutUid(layoutUid)(state) ??
      EMPTY_FORM_BEHAVIOR_STATE
    )
  })
}
